import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const violinPlotTool: Tool = {
  id: "violin-plot",
  name: () => m.violin_tool_name(),
  description: () => m.violin_tool_description(),
  icon: "🎻",
  basePath: "/violin-plot",
  status: "stable",
  tags: [
    "chart",
    "plot",
    "data-visualization",
    "violin-plot",
    "statistics",
    "science",
  ],
};
